/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendUserDashboardListResponseDto } from '../../models/backend-user-dashboard-list-response-dto';

export interface ListDashboardsMeDashboardsGet$Params {}

export function listDashboardsMeDashboardsGet(
  http: HttpClient,
  rootUrl: string,
  params?: ListDashboardsMeDashboardsGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendUserDashboardListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, listDashboardsMeDashboardsGet.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendUserDashboardListResponseDto>;
    }),
  );
}

listDashboardsMeDashboardsGet.PATH = '/me/dashboards';
